import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import ServiceFour from '../components/services/ServiceFour';
import ProjectThree from '../components/project/ProjectThree';
import FooterOne from '../common/footer/FooterOne';

const ServicesPage = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                heading="Services"
                currentPage="Services" 
            />
            <ServiceFour />
            <ProjectThree />
            <FooterOne />
        </>
    )
}

export default ServicesPage;
